<template>
  <div class="col-12 d-flex flex-wrap py-0">
    <div class="col-12 d-flex">
      <div class="col-6 py-1">
        <Label
          :field="emergencyContactsFieldsProperties('firstname')"
          :value="emergency_contact.firstname || ''"
          :text-color="getColorAlteredStatus('firstname')"
        />
      </div>

      <div class="col-6 py-1">
        <Label
          :field="emergencyContactsFieldsProperties('lastname')"
          :value="emergency_contact.lastname || ''"
          :text-color="getColorAlteredStatus('lastname')"
        />
      </div>
    </div>

    <div class="col-12 d-flex flex-wrap py-0">
      <div class="col-6 py-1">
        <Label
          :field="emergencyContactsFieldsProperties('email')"
          :value="emergency_contact.email || ''"
          :text-color="getColorAlteredStatus('email')"
        />
      </div>

      <div class="col-6 py-1">
        <Label
          :field="emergencyContactsFieldsProperties('telephone')"
          :value="emergency_contact.telephone || ''"
          :text-color="getColorAlteredStatus('telephone')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { emergencyContactsFieldsProperties } from '../../configs/forms';
import Label from '../forms/Label.vue';

export default {
  name: 'EmergencyContactsViewer',
  components: { Label },
  props: {
    index: {
      type: Number,
      default: 0
    },
    content: {
      type: Object,
      default: () => { }
    },
    contentAlteredValues: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      emergency_contact: this.content.emergency_contacts[this.index]
    }
  },
  methods: {
    emergencyContactsFieldsProperties: emergencyContactsFieldsProperties,
    getColorAlteredStatus (field) {
      let color = 'black';

      if (this.contentAlteredValues && this.contentAlteredValues.emergency_contacts && this.contentAlteredValues.emergency_contacts[this.index] && this.contentAlteredValues.emergency_contacts[this.index][field]) {
        color = 'green';
      }
      return color;
    }
  }
};
</script>

<style >
</style>
